import React from "react";
import { connect } from "react-redux";
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'

const allowedFieldTypes = [
  "text",
  "select",
  "radio",
  "checkbox",
  "textArea",
  "addressBlock",
  "serverSelect",
  "serverRadio",
  "date",
  "DateRange",
  "FullName",
  "NameOrg",
  "NameQualifiedOrg"
];

class ConstraintsEditor extends React.Component {
  state = {
    allowedFields: this.props.parentField
      ? this.props.parentField.template
          .filter(fieldId => this.props.fields[fieldId])
          .filter(fieldId =>
            allowedFieldTypes.includes(this.props.fields[fieldId].type)
          )
          .map(fieldId => ({
            value: fieldId,
            label:
              this.props.fields[fieldId].label ||
              this.props.fields[fieldId].name
          }))
      : [],
    addingConstraint: false
  };
  toggleAddingConstraint = () => {
    this.setState(state => ({ addingConstraint: !state.addingConstraint }));
  };
  addConstraint = fieldId => {
    this.props.onChange([...this.props.value, {fields: [fieldId], errorMessage: ""}]);
    this.setState({ addingConstraint: false });
  };
  addFieldByIndex = (fieldId, cIndex) => {
    this.props.onChange([
      ...this.props.value.slice(0, cIndex),
      {
        ...this.props.value[cIndex],
        fields: [...this.props.value[cIndex].fields, fieldId]
      },
      ...this.props.value.slice(cIndex + 1)
    ]);
  };
  deleteConstraintByIndex = index => {
    this.props.onChange([
      ...this.props.value.slice(0, index),
      ...this.props.value.slice(index + 1)
    ])
  }
  deleteFieldByIndex = (cI, fI) => {
    const isLastField = this.props.value[cI].fields.length === 1
    if(isLastField){
      this.deleteConstraintByIndex(cI)
    }else{
      this.props.onChange([
        ...this.props.value.slice(0, cI),
        {
          ...this.props.value[cI],
          fields: [
            ...this.props.value[cI].fields.slice(0, fI),
            ...this.props.value[cI].fields.slice(fI + 1)
          ]
        },
        ...this.props.value.slice(cI + 1)
      ])
    }
  }
  setErrorMessageByIndex = (errorMessage, index) => {
    this.props.onChange([
      ...this.props.value.slice(0, index),
      {
        ...this.props.value[index],
        errorMessage
      },
      ...this.props.value.slice(index + 1)
    ])
  }
  constructConstraints = () =>
    this.props.value.map(constraint => ({
      ...constraint,
      fields: constraint.fields
        .map(fieldId => {
          const field = this.state.allowedFields.find(
            field => field.value === fieldId
          );
          if (!field) return null;
          return field;
        })
        .filter(field => field)
    }));
  render() {
    const constraints = this.constructConstraints();
    return (
      <div className="constraints-editor">
        <p className="description">
          Constraints allow you to require that one or more fields, or a combination of fields, be unique per repeater row.
        </p>
        {
          this.state.allowedFields.length === 0 &&
          <p className="error">
            In order to create constraints, you must add at least one constrainable field to the repeater.
          </p>
        }
        {constraints.map((constraint, i) => (
          <ConstraintRow
            fieldList={constraint.fields}
            errorMessage={constraint.errorMessage}
            onErrorChange={this.setErrorMessageByIndex}
            allowedFields={this.state.allowedFields}
            addField={this.addFieldByIndex}
            onFieldDelete={this.deleteFieldByIndex}
            onConstraintDelete={this.deleteConstraintByIndex}
            index={i}
            key={i}
          />
        ))}
        {!this.state.addingConstraint && this.state.allowedFields.length > 0 ? (
          <button
            className="add-constraint"
            onClick={this.toggleAddingConstraint}
          >
            + Add New Constraint
          </button>
        ) : (
          this.state.allowedFields.length > 0 ?
          <ConstraintRow
            fieldList={[]}
            allowedFields={this.state.allowedFields}
            addField={this.addConstraint}
            onOutsideClick={this.toggleAddingConstraint}
            index={0}
          />
          : null
        )}
      </div>
    );
  }
}
export default connect(state => ({
  fields: state.designer.wizard.fields
}))(ConstraintsEditor);

class ConstraintRow extends React.Component {
  componentDidMount = () => {
    if(this.props.onOutsideClick){
      document.addEventListener('click', this.handleOutsideClick)
    }
  }
  handleOutsideClick = e => {
    if(!this.wrapper.contains(e.target)){
      this.props.onOutsideClick()
    }
  }
  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleOutsideClick)
  }
  render() {
    const { fieldList, allowedFields, addField, index, onFieldDelete, errorMessage, onErrorChange, onConstraintDelete } = this.props;
    const options = allowedFields.filter(
      opt => !fieldList.find(field => field.value === opt.value)
    );
    return (
      <div className="constraints-row" ref={ref=>{this.wrapper = ref}}>
        {
          fieldList.length > 0 &&
          <button className="delete-constraint" onClick={() => {onConstraintDelete(index)}}><CrossIcon/></button>
        }
        {
          fieldList.length > 0 &&
          <div className="field-list">
            {fieldList.map((field, i) => (
              <FieldChip {...field} onDelete={() => {onFieldDelete(index, i)}} key={i} />
            ))}
          </div>
        }
        {options.length > 0 && (
          <FieldSelector
            numFields={fieldList.length}
            options={options}
            onChange={value => {
              addField(value, index);
            }}
          />
        )}
        {
          fieldList.length > 0 && (
            <ErrorMessage value={errorMessage} onChange={value => {onErrorChange(value, index)}} />
          )
        }
      </div>
    );
  }
}

const FieldSelector = ({ onChange, options = [], numFields }) => (
  <div className="select-wrapper">
    <select
      value=""
      onChange={e => {
        onChange(e.target.value);
      }}
    >
      <option value="">{`[Select ${numFields > 0 ? 'another' : 'a'} field to constrain]`}</option>
      {options.map((option, i) => (
        <option value={option.value} key={i}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

const FieldChip = ({ label, onDelete }) => (
  <div className="field-chip-wrapper">
    <div className="field-chip">
      <button className="delete-wrapper" onClick={onDelete}>
        <div className="delete-chip"><CrossIcon/></div>
      </button>
      <span className="label">{label}</span>
    </div>
  </div>
);

const ErrorMessage = ({value, onChange}) => (
  <div className="error-message">
    <input type="text" placeholder="Enter error message (leave blank for default)" value={value} onChange={e => {onChange(e.target.value)}} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Designer2/ConstraintsEditor.js